import { Fragment, useContext} from 'react';
import { LanguageContext } from '../../index';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/Services';
import Footer from '../../components/footer/Footer';
import './style.scss'

const ServiceSinglePage = (props) => {

    const { slug } = useParams()

    const { language } = useContext(LanguageContext);
    const serviceDetails = language === 'en' ? Services.en.find(item => item.slug === slug) : Services.pl.find(item => item.slug === slug);

    return (
        <Fragment>
            <Navbar hclass={'header-style-2'} />
            <PageTitle pageTitle={serviceDetails.sTitle} pagesub={'usługi'} />
            <div className="service-single-area section-padding">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">
                            {serviceDetails.content}
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;
